module.exports = __webpack_public_path__ + "img/pdf-white-used.cd117cd6.svg";